module.exports = __webpack_public_path__ + "img/154.98762d0f.jpg";